"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { COPYRIGHT_YEAR } from "@/lib/constants";

const ROUTE_PREFIXES_TO_SHOW_FOOTER = [
  "/myAccount",
  "/myCards",
  "/myTemplates",
  "/privacy",
  "/stripe",
  "/tos",
  "/about",
  "/cookies",
  "/policies",
  "/ecards",
  "/fathersday",
];

const Footer = () => {
  const pathname = usePathname();
  const showFooter =
    ROUTE_PREFIXES_TO_SHOW_FOOTER.some((item) => {
      return pathname?.startsWith(item);
    }) || pathname === "/";

  if (!showFooter) return null;

  return (
    <footer className="flex w-full flex-row justify-center space-x-2 p-2">
      <span className="text-xs text-gray-500">© WrapDotGifts, Inc. {COPYRIGHT_YEAR}</span>
      <Link
        href="https://about.wrapdotgifts.com"
        className="text-xs text-gray-500 hover:text-gray-700"
      >
        About Us
      </Link>
      <Link
        href="/policies"
        className="text-xs text-gray-500 hover:text-gray-700"
      >
        Policies
      </Link>
      <a
        href="#"
        className="termly-display-preferences text-xs text-gray-500 hover:text-gray-700"
        onClick={(e) => {
          e.preventDefault();
          if (typeof window.displayPreferenceModal === "function") {
            window.displayPreferenceModal();
          }
        }}
      >
        Consent Preferences
      </a>
    </footer>
  );
};

export default Footer;
